import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsButton, BsCard, BsForm, BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import HiddenInput from '../../collection/inputs/HiddenInput';
import { apiForm, apiGet } from '../../utils/api';
import { appendArrayToFormData } from '../../utils/functions';
import InputEstado from '../project/InputEstado';

/**
 * Filtro adaptable para todas las tablas relativas a la validación.
 * Props:
 * - onFilter(data): Función que se ejecuta cuando se debe actualizar la tabla, la función recibe los datos del formulario de filtro y debe devolver la tabla resultante.
 * - defaultValue: Valores por defecto del filtro.
 * - selectFechas, selectDepartamento, selectTrabajador, selectVestimenta, selectEstado: Si se incluyen estas propiedades, el filtro incluirá los respectivos campos.
 */
export default function ValidacionFilter(props) {
    const { defaultValue, onFilter, ...otherProps } = props;

    const updateData = () => defaultValue;
    const saveData = async data => {
        if (!data.get("departamentos[]"))
            data.delete("departamentos[]");
        await onFilter(data);
    }

    return <BsForm
        onUpdate={updateData}
        onSave={saveData}>
        <ValidacionFilterForm
            defaultValue={defaultValue}
            {...otherProps} />
    </BsForm>;
}

class ValidacionFilterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listDepartamentos: null,
            listTrabajadores: null,
            listPrendas: null,
            listMotivos: null,
            refreshKey: Math.random(),
            refreshKeyTrabajadores: Math.random(),
            refreshKeyPrendas: Math.random()
        };
        this.refresh = this.refresh.bind(this);
        this.handleDepartamentoChange = this.handleDepartamentoChange.bind(this);
        this.handleEpiChange = this.handleEpiChange.bind(this);
    }

    componentDidMount() {
        this.updateDepartamentos();
        this.updateTrabajadores(this.props.data.departamento);
        this.updatePrendas(this.props.data.epi);
        this.updateMotivos();
    }

    refresh() {
        this.updateTrabajadores(this.props.defaultValue.departamento);
        this.updatePrendas(this.props.defaultValue.epi);
        this.setState({ refreshKey: Math.random() });
    }

    handleDepartamentoChange(element) {
        this.updateTrabajadores(element.map(d => d.value));
    }

    handleEpiChange(element) {
        this.updatePrendas(element ? element.value : element);
    }

    async updateDepartamentos() {
        if (this.props.selectDepartamento) {
            this.setState({ listDepartamentos: await apiGet("departamentos/list") });
        }
    }

    async updateTrabajadores(departamentos) {
        if (this.props.selectTrabajador) {
            let trabajadores;
            if (this.props.selectVestimenta) {
                trabajadores = await apiGet("usuarios/listvestuario");
            } else if (departamentos && departamentos.length > 0) {
                const formData = new FormData;
                appendArrayToFormData(formData, "departamentos", departamentos);
                trabajadores = await apiForm("usuarios/listtrabajadores", formData);
            } else {
                trabajadores = await apiGet("usuarios/listtrabajadores")
            }
            this.setState({
                listTrabajadores: trabajadores,
                refreshKeyTrabajadores: Math.random()
            });
        }
    }

    async updatePrendas(epi) {
        if (this.props.selectVestimenta) {
            this.setState({
                listPrendas: await apiGet("vestuario/listPrendas/" + (typeof epi === 'boolean' ? epi : "")),
                refreshKeyPrendas: Math.random()
            });
        }
    }

    async updateMotivos() {
        if (this.props.selectVestimenta) {
            this.setState({ listMotivos: await apiGet("vestuario/listMotivos") });
        }
    }

    render() {
        const data = this.props.data;
        const ready =
            (!this.props.selectDepartamento || this.state.listDepartamentos) &&
            (!this.props.selectTrabajador || this.state.listTrabajadores) &&
            (!this.props.selectVestimenta || (this.state.listPrendas && this.state.listMotivos));
        return (
            <BsCard header="Filtro" className={this.props.className} collapsed>
                {ready ? <>
                    <Row className="gy-3" key={this.state.refreshKey}>
                        {/* Fechas */}
                        {this.props.selectFechas && <>
                            <Col md="6">
                                <BsFormControl
                                    /* Desde */
                                    label="Desde" name="desde"
                                    value={data.desde}
                                    type={this.props.selectFechasMes ? "month" : "date"} />
                            </Col>
                            <Col md="6">
                                <BsFormControl
                                    /* Hasta */
                                    label="Hasta" name="hasta"
                                    value={data.hasta}
                                    type={this.props.selectFechasMes ? "month" : "date"} />
                            </Col>
                        </>}
                        {/* Usuarios */}
                        {this.props.selectDepartamento &&
                            <Col md="6">
                                <BsFormSelect
                                    /* Departamento */
                                    label="Departamento" name="departamentos[]"
                                    value={data.departamento}
                                    options={this.state.listDepartamentos}
                                    onChange={this.handleDepartamentoChange}
                                    isClearable isMulti />
                            </Col>
                        }
                        {this.props.selectTrabajador ?
                            <Col md="6">
                                <BsFormSelect
                                    /* Trabajador */
                                    label="Trabajador" name="trabajador"
                                    value={data.trabajador}
                                    options={this.state.listTrabajadores}
                                    key={this.state.refreshKeyTrabajadores}
                                    isClearable />
                            </Col> :
                            <HiddenInput name="trabajador" value={data.trabajador} />}
                        {/* Vestuario */}
                        {this.props.selectVestimenta &&
                            <>
                                <Col md={6}>
                                    <BsFormSelect
                                        /* Epi */
                                        label="Ropa / EPI" name="epi"
                                        value={data.epi}
                                        options={[{ value: false, label: "Ropa" }, { value: true, label: "EPI" }]}
                                        onChange={this.handleEpiChange}
                                        isClearable />
                                </Col>
                                <Col md="6">
                                    <BsFormSelect
                                        /* Prenda */
                                        label="Prenda" name="prenda"
                                        value={data.prenda}
                                        options={this.state.listPrendas} key={this.state.refreshKeyPrendas}
                                        isClearable />
                                </Col>
                                <Col md="6">
                                    <BsFormSelect
                                        /* Motivo */
                                        label="Motivo" name="motivo"
                                        value={data.motivo}
                                        options={this.state.listMotivos}
                                        isClearable />
                                </Col>
                            </>}
                        {/* Estado */}
                        {this.props.selectEstado &&
                            <Col md="6">
                                <InputEstado pendiente={data.pendiente} validado={data.validado} />
                            </Col>}
                    </Row>
                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <BsButton onClick={this.props.onSubmit}>Mostrar resultados</BsButton>
                        <BsButton variant="secondary" onClick={this.refresh}>Reestablecer</BsButton>
                    </div>
                </> : <Loading className="text-center" />}
            </BsCard>
        );
    }
}
